import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "device-token"
  static values = { userId: String }

  connect() {
    super.connect()

    this.send("getToken", {}, (message) => {
      const token = message.data?.token
      if (!token) return

      const storageKey = `registered_device_token_${this.userIdValue}`
      if (localStorage.getItem(storageKey) === token) return

      // Write optimistically before the fetch so sibling web views skip the
      // duplicate POST. Remove the key if the request does not succeed.
      localStorage.setItem(storageKey, token)

      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

      fetch("/dashboard/device_tokens", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({
          token: token,
          platform: document.documentElement.dataset.bridgePlatform || "ios",
          app_version: message.data?.app_version
        })
      }).then((response) => {
        if (!response.ok) {
          localStorage.removeItem(storageKey)
        }
      }).catch(() => {
        localStorage.removeItem(storageKey)
      })
    })
  }
}
